/* eslint-disable linebreak-style */
/* eslint max-len: ["error", { "code": 500 }] */
import React from 'react';
import './HomeScreen.css';

const HomeScreen = () => (
  <div className="homescreen-container">
    <h2>Welcome to our page!</h2>
    <p>Lorem Ipsum has been the industry standard dummy text ever since the 1500s. Lorem Ipsum has been the industry standard dummy text ever since the 1500s. Lorem Ipsum has been the industry standard dummy text ever since the 1500s. Lorem Ipsum has been the industry standard dummy text ever since the 1500s. Lorem Ipsum has been the industry standard dummy text ever since the 1500s.</p>
    <p>Lorem Ipsum has been the industry standard dummy text ever since the 1500s. Lorem Ipsum has been the industry standard dummy text ever since the 1500s. Lorem Ipsum has been the industry standard dummy text ever since the 1500s. Lorem Ipsum has been the industry standard dummy text ever since the 1500s. Lorem Ipsum has been the industry standard dummy text ever since the 1500s.</p>
  </div>
);

export default HomeScreen;
